import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { Notification } from 'checkout/components/Notification'

import * as S from './styled'

const Disclaimer = ({ disclaimers, ...props }) => (
  <S.Wrapper>
    <Notification {...props}>
      {
        disclaimers
          .filter(Boolean)
          .map((disclaimer, index) =>
            <Text key={index} className="notification-item" size="kilo" noMargin>
              {disclaimer}
            </Text>
          )
      }
    </Notification>
  </S.Wrapper>
)

export default Disclaimer
